<template>
  <div id="indexbox">
    <Header />
    <header-search :proshows="true" :licolors="title"></header-search>
    <!-- </header> -->
    <article class="content">
      <div class="contentt">
        <div class="leftContentt">
          <div class="ctlf">
            <ul>
              <li class="topmenu" v-for="item in menudata" :key="item.id">
                <a @click="goShopList(item.id, 0)" href="#">
                  {{ item.title }}
                  <!-- <label>></label> -->
                  <svg aria-hidden="true">
                    <use xlink:href="#iconShop_Global_Arrow_Right" />
                  </svg>
                </a>
                <ul class="childmenu">
                  <li v-for="items in item.multilines" :key="items.id">
                    <a @click="goShopList(item.id, items.id)" href="#">
                      {{
                      items.title
                      }}
                    </a>
                    <!-- <router-link>{{items.title}}</router-link> -->
                  </li>
                </ul>
              </li>
              <li class="topmenu">
                <a href="#">
                  更多
                  <svg aria-hidden="true">
                    <use xlink:href="#iconShop_Global_Arrow_Right" />
                  </svg>
                </a>
                <div class="moremodal">
                  <div v-for="item in moremenudata" :key="item.id" class="more-row">
                    <div class="morebro" @click="goShopList(item.id, 0)">{{ item.title }}</div>
                    <svg class="svg" aria-hidden="true">
                      <use xlink:href="#iconShop_Global_Arrow_Right" />
                    </svg>
                    <div class="more-box">
                      <div
                        @click="goShopList(item.id, items.id)"
                        class="morechl"
                        v-for="items in item.multilines"
                        :key="items.id"
                      >{{ items.title }}</div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="ctrtBody">
            <swiper :options="swiperOption">
              <swiper-slide v-for="(item, index) in bannerList" :key="index">
                <div class="ctrt">
                  <img :src="item.image" @click="bannerJumper(item)" />
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <right-customer></right-customer>
      </div>
      <div class="contentb">
        <div class="rxtitle">
          <label>
            <div class="icon"></div>&nbsp;热销商品
          </label>
          <div class="morepro" @click="goShopList(0, 0)">
            <a href="#">更多商品 ></a>
          </div>
        </div>
        <div class="firepro">
          <dl
            class="file-item"
            v-for="(item, index) in hotprodata"
            :key="index"
            @click="transferParameters(index)"
          >
            <dt>
              <img :src="item.images[0].url" />
            </dt>
            <dd class="d1">{{ item.title }}</dd>
            <dd class="d2">¥{{ item.price }}.00</dd>
          </dl>
        </div>
      </div>
    </article>
    <Footer />
  </div>
</template>
<script>
import Footer from "./footer";
import Header from "./header";
import headersearch from "./headersearch";
import rightCustomer from "./rightCustomer";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { mapActions } from "vuex";
// import store from "@/vuex/store";
// import myOrder from "@/components/Myorder/myOrder";

export default {
  name: "index",
  components: {
    Footer,
    Header,
    "header-search": headersearch,
    "right-customer": rightCustomer,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      menudata: [],
      moremenudata: [],
      hotprodata: [],
      moreshow: false,
      title: "首页",
      bannerList: [],
      userInfo: {},
      swiperOption: {
        autoplay: {
          delay: 5000
        },
        sepeed: 1000,
        loop: true
      }
    };
  },
  created() {
    this.rqmenudata();
    this.rqhotprodata();
    this.getBanner();
    this.userInfo = this.$store.state.userInfo;
  },

  methods: {
    ...mapActions(["login"]),
    rqmenudata(key = null) {
      this.$http.getmenudata(key).then(res => {
        // debugger
        if (res.code == 200) {
          if (res.category) {
            // if (res.category.length > 11) {
            this.menudata = res.category.slice(0, 11);
            this.moremenudata = res.category;
            // }else{
            //   this.menudata = res.category;
            // }
          }
        } else {
          console.log(res.msg);
        }
      });
    },
    rqhotprodata(key = null) {
      this.$http.getTagProduct({ limit: 8, page: 1, kind: 4 }).then(res => {
        if (res.code == 200) {
          this.hotprodata = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    getBanner() {
      this.$http.getBanner().then(res => {
        console.log(res);
        if (res.code == 200) {
          this.bannerList = res.banners;
        }
      });
    },
    bannerJumper(item) {
      console.log(item);
      if (item.kind == 0) {
        window.open(item.url, "_blank");
      } else {
        this.$router.push({
          path: "detail",
          query: {
            detail: item.url
            //通过query 传递参数
          }
        });
      }
    },
    transferParameters(index) {
      let pid = `pid${index}`;
      // console.log(this.hotprodata[index]);
      // localStorage.setItem(pid, JSON.stringify(this.hotprodata[index]));
      this.$router.push({
        path: "detail",
        query: {
          detail: this.hotprodata[index].id
          //通过query 传递参数
        }
      });
    },
    goShopList(classifyId, categoryId) {
      let pid = `classify${classifyId}`;
      var prames = {
        selectClassify: classifyId,
        selectcategoryId: categoryId
      };
      localStorage.setItem(pid, JSON.stringify(prames));
      this.$router.push({
        path: "shopList",
        query: {
          select: pid
          //通过query 传递参数
        }
      });
    }
  }
  // store
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped >
#indexbox {
  // border: 1px dashed red;
  .content {
    padding: 8px;
    background: #f7f7f7;
    width: 100%;
    // width: 1200px;
    // height: 40px;
    // margin: 0 auto;
    // border: 1px dashed orange;
    .contentt {
      width: 100%;
      width: 1200px;
      margin: 0 auto;
      // border: 1px dashed orangered;
      .leftContentt {
        width: 1200px;
        margin: 0 auto;
        // border: 1px dashed red;
        .ctlf {
          width: 162px;
          float: left;
          position: relative;
          background-color: #ffffff;
          padding: 12.5px 0;
          ul,
          li {
            list-style-type: none;
            margin: 0;
            padding: 0;
          }
          .topmenu {
            width: 160px;
            height: 32px;
            line-height: 32px;
            text-align: left;
            position: relative;
            cursor: pointer;
            padding: 0 10px;
            a {
              text-decoration: none;
              font-size: 14px;
              padding: 0 10px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              // label {
              //   float: right;
              //   margin-right: 20px;
              // }
              svg {
                width: 10px;
                height: 10px;
                float: right;
                margin-right: 20px;
                margin-top: 10px;
              }
            }
            ul.childmenu {
              display: none;
              // display: block;
              background-color: rgba(255, 255, 255, 1);
              width: 1000px;
              padding: 0 10px;
              // height: 100%;
              position: absolute;
              z-index: 999;
              left: 160px;
              top: 0px;
              li {
                width: auto;
                height: auto;
                // display: inline-block;
                float: left;
                margin-top: 0px;
                a {
                  font-size: 12px;
                  font-weight: 400;
                  color: rgba(0, 0, 0, 0.65);
                }
              }
              li:hover {
                background-color: white;
              }
              li:hover {
                background-color: #f0f0f0;
              }
            }
            .moremodal {
              display: none;
              // display: block;
              width: 1032px;
              background-color: #ffffff;
              position: absolute;
              left: 160px;
              z-index: 999;
              top: -460px;
              .more-row {
                // border: 1px dashed red;
                width: 100%;
                display: inline-flex;
                .morebro {
                  width: 80px;
                  font-size: 12px;
                  margin-left: 10px;
                  font-weight: 500;
                  color: rgba(0, 0, 0, 0.85);
                  text-align: left;
                  display: inline-block;
                  // border: 1px dashed red;
                  position: relative;
                }

                .svg {
                  width: 10px;
                  height: 10px;
                  float: right;
                  margin-right: 20px;
                  margin-top: 10px;
                }

                .more-box {
                  // border: 1px dashed orangered;
                  width: calc(100% - 80px);
                  .morechl {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.65);
                    //  width: 100%;
                    display: inline-block;
                    // margin-left: 30px;
                    padding: 0 10px;
                    // border: 1px dashed black;
                  }
                }
                .morechl:hover {
                  background: #f0f0f0;
                }
              }
              .more-row:hover {
                .morebro {
                  background: #f0f0f0;
                }
              }
            }
          }
          li:not(:first-child) {
            margin-top: 8.7px;
          }
          li:hover {
            background-color: #f0f0f0;
          }
          li.topmenu:hover ul {
            display: block;
          }
          li.topmenu:hover .moremodal {
            display: block !important;
          }
        }
        .ctrtBody {
          width: 1035px;
          height: 504px;
          float: left;
          // border: 1px dashed red;
          .ctrt {
            float: left;
            img {
              width: 1032px;
              height: 504px;
              // background: gray;
            }
          }
        }
      }
    }
    .content::after {
      clear: both;
    }
    .contentb {
      width: 1200px;
      margin: 0 auto;
      // clear: both;
      // border: 1px dashed red;
      // background: #f0f0f0;
      .rxtitle {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        // border: 1px dashed red;
        label {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
        }
        .icon {
          width: 3px;
          height: 15px;
          background-color: red;
          display: inline-block;
        }
        .morepro {
          position: absolute;
          right: 0px;
          bottom: 0px;
          a {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            text-decoration: none;
          }
        }
      }

      .firepro {
        background: #f7f7f7;
        // border: 1px dashed black;
        display: inline-flex;
        flex-wrap: wrap;
        dl {
          margin: 0;
        }
        dl.file-item {
          width: 288px;
          height: 380px;
          background-color: #ffffff;
          // float: left;
          // margin: 6px;
          margin-bottom: 14px;
          // border: 1px dashed red;
          cursor: pointer;
          dt {
            // margin: 10px;
            text-align: center;
            padding: 10px;
            img {
              width: 270px;
              height: 270px;
              filter: invert(0.08);
            }
          }
          dd {
            text-align: left;
            margin: 10px;
          }
          .d1 {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
          }
          .d2 {
            font-size: 18px;
            font-family: HelveticaNeue-Bold, HelveticaNeue;
            font-weight: bold;
            color: rgba(239, 45, 35, 1);
          }
        }
        .file-item:not(:nth-child(4n)) {
          margin-right: 14px;
        }
      }
    }
  }
}
</style>
